export const WORK_DAYS_OF_WEEK = ['MONDAY', 'TUESDAY',  'WEDNESDAY', 'THURSDAY', 'FRIDAY']
export const START_TIME = '11:00'
export const END_TIME = '14:30'

export const orderTypeLabelsV2 = {
	DELIVERY: 'product.form.menuV2.orderTypes.delivery',
	PICKUP: 'product.form.menuV2.orderTypes.pickup',
	COUNTER: 'product.form.menuV2.orderTypes.counter',
	RESTAURANT: 'product.form.menuV2.orderTypes.restaurant',
}

export const productTypeLabelsV2 = {
	MAIN_DISH: 'product.form.productV2.typeOptions.MAIN_DISH',
	TOPPING: 'product.form.productV2.typeOptions.TOPPING',
	BEVERAGE: 'product.form.productV2.typeOptions.BEVERAGE',
	BOTTLE_DEPOSIT: 'product.form.productV2.typeOptions.BOTTLE_DEPOSIT',
	TOBACCO: 'product.form.productV2.typeOptions.TOBACCO',
	BASIC_FOOD: 'product.form.productV2.typeOptions.BASIC_FOOD',
}

export const taxProductTypeOptions = ['MAIN_DISH', 'BEVERAGE']
export const austrianTaxProductTypeOptions = [...taxProductTypeOptions, 'BASIC_FOOD']
